import { ArgumentValidator } from "@/shared/helpers";

export class HttpClientHelper {

    public static getFilenameFromContentDisposition(cd?: string): string | null {
    
        if (!cd) {
            return null;
        }

        const utf8 = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)?.[1];

        if (utf8) {
            try {
                return decodeURIComponent(utf8);
            } catch { 
                /* ignore */ 
            }
        }

        // Support for filename="..."/filename=...
        const quoted = cd.match(/filename\s*=\s*"([^"]+)"/i)?.[1];
        if (quoted) {
            return quoted.trim();
        }

        const bare = cd.match(/filename\s*=\s*([^;]+)/i)?.[1];
        if (bare) {
            return bare.trim();
        }

        return null;
    }

    public static readFileAsBase64(file: File): Promise<string> {

        ArgumentValidator.notNullOrEmpty(file, `file`);

        return new Promise<string>((resolve, reject) => {

            const reader = new FileReader();

            reader.onload = () => {

                const result = reader.result as string;
                const base64 = result.substring(result.indexOf(',') + 1);

                resolve(base64);
            };

            reader.onerror = () => reject(reader.error);

            reader.readAsDataURL(file);
        });
    }

    public static triggerFileDownload(blob: Blob, fileName: string): void {

        ArgumentValidator.notNullOrEmpty(blob, `blob`);
        ArgumentValidator.notNullOrEmpty(fileName, `fileName`);

        const blobUrl = window.URL.createObjectURL(blob);

        // Create temporary <a>-tag and trig download
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(blobUrl);
    }
}